import { Alert, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { editUserByAdmin } from '../../api/api-middleware';
import Modal from '../elements/Modal';
import ResetPasswordForm from './ResetPasswordForm';

export default function ResetPassword({
  user,
  fetchData,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    setUserData({ ...user });
  }, [user]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSubmit = async (values) => {
    setError(null);

    try {
      const user = {
        ...values,
      };
      let response = await editUserByAdmin(userData.id, user, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }
      fetchData();
      handleClose();
      setMessage('User password reset successfully');
      setSnackbarOpen(true);
    } catch (error) {
      setError('Failed to add a reset password. ' + error.message);
    }
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleClickOpen}>
        Reset Password
      </Button>
      <Modal
        open={open}
        width={'xs'}
        modalTitle="Reset Password"
        handleClose={handleClose}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <ResetPasswordForm onSubmit={handleSubmit} />
      </Modal>
    </>
  );
}
